<template>
  <a-drawer
    v-model:visible="open"
    class="custom-class"
    root-class-name="root-class-name"
    :root-style="{ color: 'blue' }"
    style="color: red"
    :title="title || '问卷中心'"
    destroyOnClose
    placement="right"
    width="391"
    @after-open-change="afterOpenChange"
    :bodyStyle="{ padding: '0' }"
    id="drawer"
  >
    <iframe :src="url" width="100%" :height="drawerHeight - 60 + 'px'" frameborder="0"></iframe>
  </a-drawer>
</template>
<script setup>
import { defineExpose, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import { ref, defineProps } from 'vue'
const open = ref(false)
// 获取drawer的高度
const drawerHeight = ref(0)
defineProps({
  url: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  }
})
// 更新高度的方法
const updateDrawerHeight = () => {
  const drawerElement = document.getElementById('drawer')
  if (drawerElement) {
    drawerHeight.value = drawerElement.offsetHeight
  }
}

// 监听窗口大小变化
const handleResize = () => {
  if (open.value) {
    updateDrawerHeight()
  }
}

// 监听open变化，当打开时初始化高度
watch(open, newVal => {
  if (newVal) {
    nextTick(() => {
      // 多次尝试获取高度，确保drawer完全展开
      setTimeout(updateDrawerHeight, 0)
      setTimeout(updateDrawerHeight, 100)
      setTimeout(updateDrawerHeight, 300)
    })
  }
})

// 组件挂载时添加事件监听
onMounted(() => {
  window.addEventListener('resize', handleResize)
})

// 组件卸载前移除事件监听
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})

const afterOpenChange = bool => {
  if (bool) {
    // 当抽屉打开后，立即更新高度
    // 使用 setTimeout 确保 DOM 已完全渲染
    setTimeout(updateDrawerHeight, 100)
  }
}

const showDrawer = () => {
  open.value = true
}

const hideDrawer = () => {
  open.value = false
}

defineExpose({
  showDrawer,
  hideDrawer
})
</script>
<style lang="scss" scoped></style>
